import React from 'react'
import PropTypes from 'prop-types'
import {
  FieldQuestionLabel,
  ProgramRoleWrapper,
  ProgramRoleHeader,
  SelectField,
} from './component.styles'
import { withTheme } from 'styled-components'

const AddProgramRole = ({
  errors,
  handleChange,
  entry,
  theme,
  touched,
  values,
}) => {
  const { header, choiceContent = [] } = entry || {}
  const {
    answerChoice1: teachChoice1,
    answerChoice2: teachChoice2,
    questionText: teachQuestionText,
  } = choiceContent[0] || {}
  const {
    answerChoice1: yearsChoice1,
    answerChoice2: yearsChoice2,
    answerChoice3: yearsChoice3,
    questionText: yearsQuestionText,
  } = choiceContent[1] || {}

  return (
    <ProgramRoleWrapper>
      <ProgramRoleHeader>{header}</ProgramRoleHeader>
      <FieldQuestionLabel htmlFor="teaching-role-select">
        {teachQuestionText}
      </FieldQuestionLabel>
      <SelectField
        dataTestId="teaching-role-select"
        error={touched.teachesLessonsAnswer && errors.teachesLessonsAnswer}
        iconColor={theme?.colors?.gray1200}
        label="Teaching Role"
        name="teachesLessonsAnswer"
        onChange={event => handleChange('teachesLessonsAnswer', event?.value)}
        options={[teachChoice1, teachChoice2]}
        value={values.teachesLessonsAnswer}
      />
      <FieldQuestionLabel htmlFor="years-select">
        {yearsQuestionText}
      </FieldQuestionLabel>
      <SelectField
        dataTestId="years-select"
        error={touched.yearsTeaching && errors.yearsTeaching}
        iconColor={theme?.colors?.gray1200}
        label="Years"
        name="yearsTeaching"
        onChange={event => handleChange('yearsTeaching', event?.value)}
        options={[yearsChoice1, yearsChoice2, yearsChoice3]}
        value={values.yearsTeaching}
      />
    </ProgramRoleWrapper>
  )
}

AddProgramRole.propTypes = {
  entry: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  theme: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default withTheme(AddProgramRole)
